export const itemHeaderFlag = "_qc";
export default {itemHeaderFlag};